import {Tr} from "@/i18n/i18n";
import Scene = Phaser.Scene;
import {Keys} from "@/constants/key";
import TextUtils from "@/utils/text-utils";
import {ArtifactNotification} from "@/store/artifact/types";
import Container = Phaser.GameObjects.Container;
import {Fonts} from "@/constants/font";
import {BasePanel} from "@/scenes.ui/base-panel";
import SceneUtils from "@/utils/scene-utils";
import ArtifactUtils from "@/utils/artifact-utils";
import SpriteUtils from "@/utils/sprite-utils";
import CU from "@/utils/c-u";

export class NotificationPanel extends BasePanel {

    constructor(scene: Scene, canvas: HTMLCanvasElement, nt: ArtifactNotification, container?: Container) {
        super(scene, canvas, 300 * CU.S, 0, container);
        this.setDepth(5000);
        const self = this;

        let blackout = SpriteUtils.addSprite(this.scene, 0, 50, Keys.EDU_BLACKOUT);

        let background = SpriteUtils.addSprite(this.scene, 0, 80, Keys.UI_NOTIF_PANEL);

        let updateText = TextUtils.addTextByFamily(scene, Tr('zaversheno.uluchshenie'),
            0, 55, '#ffe8ba', 15, 'normal', 450, Fonts.MYRIADPRO_BOLD);

        let xButton = SpriteUtils.addImage(this.scene, 226, 50, Keys.ATLAS_UI, Keys.UI_WINDOW_X_CUTE, 0.7).setOrigin(0.5, 0.5).setAlpha(0.6);

        xButton.setInteractive().on('pointerup', function() {
            if (self.isOnTop()) {
                self.close();
            }
        });

        let lightFrom = SpriteUtils.addSprite(this.scene, -60, 90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.4);
        let lightTo = SpriteUtils.addSprite(this.scene, 60, 90, Keys.ATLAS_PROFILE, Keys.UI_ART_LIGHT, 0.4);
        let itemFrom = SpriteUtils.addSprite(this.scene, -60, 90, nt.atlasKey, nt.prevImageKey, 0.5);
        let fromText = TextUtils.addTextAdvanced(scene, ArtifactUtils.getEffectText(nt.effectType, nt.prevLevelValue), -60, 110,
            '#e0e0e0', 11, 'normal', 130, 'center', 2, Fonts.ARIAL_MT);
        let itemArr = SpriteUtils.addSprite(this.scene, 0, 90, Keys.ATLAS_PROFILE, Keys.UI_ART_ARR, 0.5);
        let itemTo = SpriteUtils.addSprite(this.scene, 60, 90, nt.atlasKey, nt.nextImageKey, 0.5);
        let toText = TextUtils.addTextAdvanced(scene, ArtifactUtils.getEffectText(nt.effectType, nt.nextLevelValue), 60, 110,
            '#85ff85', 11, 'normal', 130, 'center', 2, Fonts.ARIAL_MT);

        this.add([blackout, background, updateText, xButton, lightFrom, lightTo, itemFrom, itemArr, itemTo, fromText, toText]);
    }

    public open(): void {
        super.open();
        this.y = -200 * CU.S;
        SceneUtils.getCurrentScene().tweens.add({
            targets: this,
            y: 0,
            delay: 0,
            duration: 1000
        });

        let self = this;
        SceneUtils.getCurrentScene().time.delayedCall(7000, () => {
            self.close();
        });
    }

    public close(): void {
        BasePanel.stack = BasePanel.stack.filter(p => p != this);
        if (this.closeListener != null) {
            this.closeListener();
        }
        let self = this;
        SceneUtils.getCurrentScene().tweens.add({
            targets: this,
            y: -200 * CU.S,
            delay: 0,
            duration: 1500,

            onComplete() {
                self.setVisible(false);
                self.destroy();
            }
        });
    }
}
